// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.pipbar {\n  display: flex;\n  flex-wrap: wrap;\n}\n.pipbar .v-icon {\n  padding: 0px 0px !important;\n}\n.pipbar .v-icon .v-ripple__container {\n  width: 32px !important;\n  height: 28px !important;\n  left: -1px !important;\n}\n.pipinput {\n  height: 28px;\n  font-weight: bold;\n  width: fit-content;\n  margin-top: 2px;\n  max-width: 30px;\n}\n.pipinput:focus {\n  outline: none;\n}\n.v-rating--dense .v-icon {\n  padding: 0;\n}\n", ""]);
// Exports
module.exports = exports;
